"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Canva;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var defaultState = _immutable.default.Map({
  downloadStatus: _Constants.RequestStatus.UNINITIALIZED,
  initStatus: _Constants.RequestStatus.UNINITIALIZED
});

function Canva() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    case _ActionTypes.CANVA_INIT_ATTEMPTED:
      return state.set('initStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes.CANVA_INIT_SUCCEEDED:
      return state.set('initStatus', _Constants.RequestStatus.SUCCEEDED);

    case _ActionTypes.CANVA_INIT_FAILED:
      return state.set('initStatus', _Constants.RequestStatus.FAILED);

    case _ActionTypes.DOWNLOAD_FROM_CANVA_ATTEMPTED:
      return state.merge({
        downloadStatus: _Constants.RequestStatus.PENDING
      });

    case _ActionTypes.DOWNLOAD_FROM_CANVA_SUCCEEDED:
      return state.merge({
        downloadStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.DOWNLOAD_FROM_CANVA_FAILED:
      return state.merge({
        downloadStatus: _Constants.RequestStatus.FAILED
      });

    default:
      return state;
  }
}

module.exports = exports.default;